<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="pttblue dark text-white print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.futuristic" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->

    <ng-container fuseVerticalNavigationHeader>
        <!-- Logo -->
        <div class="flex items-center h-18 p-6 bg-white border-white">
            <img alt="ptt logo" class="w-30" src="assets/images/logo/ptt-logo1.png">
        </div>
    </ng-container>

    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>

    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
        class="relative flex flex-0 items-center w-full h-18 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <span class="material-symbols-outlined"> menu </span>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
        
            <notifications></notifications>
            <!-- User -->

            <div class="flex items-center w-full px-6 py-8 border-t">

            
                <span class="icon-size-8 material-symbols-outlined"> account_circle </span>
                <div class="flex flex-col w-full ml-4 overflow-hidden pr-4">
                    <div
                        class="w-full whitespace-nowrap text-ellipsis overflow-hidden leading-normal text-current opacity-80">
                        {{user.name}}
                    </div>
                    <div
                        class="w-full mt-0.5 whitespace-nowrap text-sm text-ellipsis overflow-hidden leading-normal text-current opacity-50">
                        {{user.role}}
                    </div>
                </div>
                <div>
                    <button mat-menu-item (click)="signOut()">
                        <span class="material-symbols-outlined"> logout </span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto"> 
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
    
        <span class="font-medium text-secondary">บริษัท ปตท. จำกัด (มหาชน) <br>
            555 ถนนวิภาวดีรังสิต แขวงจตุจักร เขตจตุจักร กรุงเทพฯ 10900</span>
    </div>

</div>
